module.exports = __webpack_public_path__ + "img/TZS09667.d89eedd7.jpeg";